import api from '../../store/config/api';
import { GROUP as SCHEMA, USER_LIST as MEMBER_LIST } from '../../schemas';

export const [
  GET_GROUP,
  GET_GROUP_REQUEST,
  GET_GROUP_SUCCESS,
  GET_GROUP_FAILURE
] = api.buildTypes('GET_GROUP');

/**
 * GET a specific group
 * @param teamName {string}
 * @param {string} groupName - The `username` of the group.
 */
export function getGroup({ teamName, groupName }) {
  return {
    type: GET_GROUP,
    payload: {
      url: `/teams/${teamName}/groups/${groupName}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  CREATE_GROUP,
  CREATE_GROUP_REQUEST,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_FAILURE
] = api.buildTypes('CREATE_GROUP');

/**
 * Create a new group.
 * @param teamName {string}
 * @param {Object} group
 * @param {string} group.username - The name of the group.
 * @param {string} [group.nickname] -  Alternate display name for the group, if the ideal `username` is not available.
 * @param {string[]} [group.members] - Array of team members' `username`s to invite to the group.
 */
export function createGroup({ teamName, group = {} }) {
  return {
    type: CREATE_GROUP,
    payload: {
      url: `/teams/${teamName}/groups`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: group
      }
    }
  };
}

export const [
  UPDATE_GROUP,
  UPDATE_GROUP_REQUEST,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_FAILURE
] = api.buildTypes('UPDATE_GROUP');

/**
 * Update an existing group. When updating the list of members in a group (adding or removing members),
 * ensure that the entire new list of users is passed. When adding a member,
 * an invitation notification will automatically be sent.
 *
 * @param {string} teamName - The `username` of the group.
 * @param {Object} group - The updated group object.
 */
export function updateGroup({ teamName, group }) {
  return {
    type: UPDATE_GROUP,
    payload: {
      url: `/teams/${teamName}/groups/${group.username}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: group
      }
    }
  };
}

export const [
  DELETE_GROUP,
  DELETE_GROUP_REQUEST,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_FAILURE
] = api.buildTypes('DELETE_GROUP');

/**
 * Mark a group as archived.
 * @param teamName {string}
 * @param {string} groupName - The `username` of the group to be archived.
 */
export function deleteGroup({ teamName, groupName }) {
  return {
    type: DELETE_GROUP,
    payload: {
      url: `/teams/${teamName}/groups/${groupName}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}

export const [
  GET_GROUP_MEMBERS,
  GET_GROUP_MEMBERS_REQUEST,
  GET_GROUP_MEMBERS_SUCCESS,
  GET_GROUP_MEMBERS_FAILURE
] = api.buildTypes('GET_GROUP_MEMBERS');

/**
 * Retrieve the group members as an array of user objects.
 * @param teamName {string}
 * @param {string} groupName - The `username` of the group.
 */
export function getGroupMembers({ teamName, groupName }) {
  return {
    type: GET_GROUP_MEMBERS,
    payload: {
      url: `/teams/${teamName}/groups/${groupName}/members`,
      schema: MEMBER_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/group.js